import React, { useState, useRef } from "react";
import "./styles.less";
import classnames from "classnames";

export const AuthingButton = (props) => {
  const { children, onClick, className, mode, style, size } = props;
  const cls = classnames({
    "authing-button-new": true,
    [mode]: mode,
    [className]: !!className,
    [size]: size,
  });
  const buttonRef = useRef();
  const buttonMaskRef = useRef();
  const buttonMaskFlagRef = useRef();
  const [show, setShow] = useState(false);
  const [transform, setTransform] = useState("");
  const onMouseEnter = () => {
    setShow(true);
  };
  const onMouseMove = (e) => {
    // onMouseLeave 很多时候触发不了，所以模拟了一个边界测定
    if (
      e.clientX >= buttonRef.current.getBoundingClientRect().x &&
      e.clientX <= buttonMaskFlagRef.current.getBoundingClientRect().x &&
      e.clientY >= buttonRef.current.getBoundingClientRect().y &&
      e.clientY <= buttonMaskFlagRef.current.getBoundingClientRect().y
    ) {
      setTransform(
        `translate(${
          e.clientX - buttonRef.current.getBoundingClientRect().x
        }px,${e.clientY - buttonRef.current.getBoundingClientRect().y}px)`
      );
    }
  };
  const onMouseLeave = (e) => {
    setShow(false);
  };

  return (
    <button
      className={cls}
      {...{ onClick, style }}
      onMouseEnter={onMouseEnter}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
      ref={buttonRef}
    >
      <span style={{ zIndex: 1 }}>{children}</span>
      <div
        className="btn-mask"
        style={{
          display: show ? "block" : "none",
          transform: transform,
        }}
        ref={buttonMaskRef}
      ></div>
      {/* onMouseLeave不能很好的监听离开状态出此下策 */}
      <div className="btn-mask-flag" ref={buttonMaskFlagRef}></div>
    </button>
  );
};
export const AuthingButtonArrow = (props) => {
  const { children, onClick, className, mode, style } = props;
  const cls = classnames({
    "authing-button-arrow": true,
    [className]: !!className,
    [mode]: mode,
  });
  return (
    <button className={cls} {...{ onClick, style }}>
      {children}
      <i
        class="icon authing-icon authing-arrow-right-line"
        style={{ marginLeft: 4 }}
      ></i>
    </button>
  );
};
